import { gql } from "@apollo/client";

export const GUIDE_EDITOR_SCHEDULER_CONFIG_AVAILABILITY_FRAGMENT = gql`
  fragment GuideEditorSchedulerConfigAvailabilityFragment on SchedulerAvailability {
    id
    name
  }
`;

export const GUIDE_EDITOR_SCHEDULER_CONFIG_EVENT_TEMPLATE_FRAGMENT = gql`
  fragment GuideEditorSchedulerConfigEventTemplateFragment on EventTemplate {
    id
    title
  }
`;
